import PropTypes from "prop-types";

const MODELS = [
  {
    icon: "/b2b/training1.svg",
    title: "Every role. No filler.",
    description:
      "Curriculum mapped to each role's actual tasks. Zero filler.",
  },
  {
    icon: "/b2b/training2.svg",
    title: "Built around your stack.",
    description:
      "Online, in-person or blended, built around your workflows.",
  },
  {
    icon: "/b2b/training3.svg",
    title: "Practitioners, not trainers",
    description:
      "Every session led by practitioners who ship AI for a living.",
  },
  {
    icon: "/b2b/training4.svg",
    title: "A real L&D partner.",
    description:
      "Dedicated PM, live dashboards, and a full outcomes report.",
  },
];

const ModelCard = ({ model }) => (
  <div className="shrink-0 w-[280px] md:w-auto bg-[#1C1C1C] border border-[#F8F8F833] rounded-[4px] p-6 flex flex-col">
    <img
      src={model.icon}
      alt=""
      className="h-7 w-7"
      loading="lazy"
      decoding="async"
    />
    <h3 className="mt-6 text-white text-[18px] md:text-[20px] font-medium leading-snug">
      {model.title}
    </h3>
    <p className="mt-3 text-white/60 text-sm md:text-base leading-relaxed">
      {model.description}
    </p>
  </div>
);

ModelCard.propTypes = {
  model: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

const BusinessPartnership = () => {
  return (
    <section
      id="business-partnership"
      data-section-theme="light"
      className="w-full bg-white font-fira-sans"
      style={{
        borderTop: "1px solid #08090A33",
        borderBottom: "1px solid #08090A33",
      }}
    >
      <div
        className="w-[90%] md:w-auto mx-auto md:mx-[153px]"
        style={{
          borderLeft: "1px solid #08090A33",
          borderRight: "1px solid #08090A33",
        }}
      >
        <div className="px-4 md:pl-[60px] md:pr-[60px] py-16">
          <p className="text-black uppercase tracking-[1.75px] text-sm mb-4">
            Partnership Models
          </p>
          <h2 className="text-black text-[30px] md:text-[42px] font-medium leading-tight">
            The AI training your competitors wish they&apos;d done first
          </h2>
          <p className="mt-4 text-black/60 text-sm md:text-base leading-relaxed max-w-2xl">
            Not a generic course platform. Not a one-off workshop. A fully
            custom program built around how your team actually works.
          </p>

          {/* Desktop: 4-column grid */}
          <div className="hidden md:grid grid-cols-4 gap-5 mt-12">
            {MODELS.map((model) => (
              <ModelCard key={model.title} model={model} />
            ))}
          </div>

          {/* Mobile: horizontal scroll, kept inside the rails */}
          <div className="md:hidden mt-10 -mx-4">
            <div
              className="overflow-x-auto px-4"
              style={{ scrollbarWidth: "thin" }}
            >
              <div className="flex gap-4 pb-2">
                {MODELS.map((model) => (
                  <ModelCard key={model.title} model={model} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessPartnership;
